import React, { useContext } from 'react';

import Stepper from '../stepper/stepper';
import Footer from '../footer';
import { RequestAccessFormContext } from '../../contexts/request-access-form-context';
import AccessGrantedBody from './access-granted-body';

const AccessGranted = () => {
    const { setStep } = useContext(RequestAccessFormContext);

    const handleGoBack = () => {
        setStep(0);
    };

    return (
        <>
            <Stepper label="app.request.access.public.step.3.navbar.label" />
            <AccessGrantedBody />
            <Footer
                buttonLabel="app.request.access.public.step.3.submit.button"
                buttonProps={{
                    onClick: handleGoBack,
                }}
            />
        </>
    );
};

export default AccessGranted;
